export const API_ROUTES = {
  // User
  USER: 'web-authentication/profile',

  // Authentication
  START_ACTIVATION: 'authentication/start-activation/',
  ACTIVATION_CHALLENGE_VALIDATION:
    'authentication/activation-challenge-validation/',
  SET_PASSWORD: 'authentication/set-password/',
  RESEND_ACTIVATION_INVITATION: 'authentication/resend-activation-invitation/',
  RESET_PASSWORD: 'authentication/start-reset-password/',
  RESET_PASSWORD_WEB: 'authentication/set-new-password/',
  RESET_PASSWORD_CHALLENGE_VALIDATION:
    'authentication/reset-password-challenge-validation/',
  UPDATE_PASSWORD: 'authentication/update-password/',
  START_UPDATE_EMAIL: 'authentication/start-update-email/',
  UPDATE_EMAIL: 'authentication/update-email/',
  AUTH_SET_PASSWORD: 'authentication/set-password/',
  UPDATE_ADDRESS: 'consumers/update-address',

  // Web Authentication
  INITIATE_AUTH: 'web-authentication/initiate-auth/',
  AUTH_CHALLENGE_VALIDATION: 'web-authentication/auth-challenge-validation/',
  REFRESH_TOKEN: 'web-authentication/refresh-token/',
  UPDATE_STAFF_PROFILE: 'web-authentication/staff-profile',
  UPDATE_ADVISOR_PROFILE: 'web-authentication/teammate-profile',

  // Password Update
  START_UPDATE_PHONE_NUMBER: 'authentication/start-update-phone-number/',
  UPDATE_PHONE_NUMBER: 'authentication/update-phone-number/',
  GET_COGNITO_USER_INFO: 'authentication/user-info/',
  REGISTER_BIOMETRICS: 'authentication/register-biometrics/',
  START_CUSTOM_AUTH: 'authentication/initiate-custom-auth/',
  CUSTOM_AUTH_CHALLENGE_VALIDATION:
    'authentication/custom-auth-challenge-validation/',
  LOGOUT: 'authentication/logout/',

  // Help
  HELP: 'help/',

  // Branding Themes
  BRANDING_THEMES: 'branding-themes/',

  // Banking Info
  BANKING_INFO: 'banking-info/',

  // Bank Accounts
  BANK_ACCOUNTS: 'bank-accounts/',
  REVEAL_ACCOUNT_NUMBER: 'reveal-account-number/',

  // Bank Applications
  BANK_APPLICATIONS: 'bank-applications/',

  // External Accounts
  EXTERNAL_ACCOUNTS: 'external-accounts/',

  // Deposit Sweep
  DEPOSIT_SWEEP: 'deposit-sweeps/',

  // Authorized Teammates
  AUTHORIZED_TEAMMATES: 'authorized-teammates/',

  // Transactions
  TRANSACTIONS: 'transactions/',

  // Scheduled Transactions
  SCHEDULED_TRANSACTIONS: 'scheduled-transactions',

  // Transaction Requests
  TRANSACTION_REQUEST: 'transaction-requests/',
  UNDER_REVIEW: 'under_review',

  // Teammates
  TEAMMATES: 'teammates/',

  // Companies
  COMPANIES: 'companies/',

  // Staff
  STAFF: 'staffs/',

  // Customers
  CUSTOMERS: 'consumers/',
  WIRE_RECIPIENTS: '/third-party-recipients',

  //  Lending
  _LENDING: '/lending/loan-requests/',

  // Businesses
  BUSINESSES: 'businesses/',

  // Program Settings
  PROGRAM_SETTINGS: '/settings/',

  // Presigned Urls
  PRESIGNED_URL: '/presigned-urls',
};
